import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginComponent from '../components/login/LoginComponent'
import CloseRequestPasswordComponent from '../components/closerequestpassword/CloseRequestPasswordComponent'
import AdminComponent from '../components/AdminComponent'
import DashboardComponent from '../components/dashboard/DashBoardComponent'
import UserComponent from '../components/users/UserComponent'
import BranchComponent from '../components/branches/BranchComponent'
import TenantComponent from '../components/tenants/TenantComponent'
import BuilderComponent from '../components/builders/BuilderComponent'
import CondominiumComponent from '../components/condominiums/CondominiumComponent'
import PropertyComponent from '../components/properties/PropertyComponent'
import PropertyMenuComponent from '@/components/properties/PropertyMenuComponent'
import FavoriteComponent from '../components/favorites/FavoriteComponent'
import FacComponent from '../components/facs/FacComponent.vue'
import UserRequestComponent from '../components/user_requests/UserRequestComponent'

// properties 2
import PropertyIndex from '@/components/properties2/PropertyIndex.vue'
import PropertyStore from '@/components/properties2/PropertyStore.vue'
import PropertyFilter from '@/components/properties2/PropertyFilter.vue'
import PropertySearch from '@/components/properties2/PropertySearch.vue'
import PropertyIndexShow from '@/components/properties2/PropertyIndexShow.vue'
import PropertyEdit from '@/components/properties2/PropertyEdit.vue'
import PropertyDeleted from '@/components/properties2/PropertyDeleted.vue'
import PropertyPortalSummary from '@/components/properties2/PropertyPortalSummary.vue'
import ShopWindow from '@/components/properties2/ShopWindow.vue'
// end properties 2

// facs 2
import FacIndex from '@/components/facs2/FacIndex.vue'
import FacStore from '@/components/facs2/FacStore.vue'
import FacEdit from '@/components/facs2/FacEdit.vue'
import FacFilter from '@/components/facs2/FacFilter.vue'
import FacSearch from '@/components/facs2/FacSearch.vue'
// end facs 2


// proposal 2
import ProposalIndex from '@/components/proposals/ProposalIndex.vue'
import ProposalStore from '@/components/proposals/ProposalStore.vue'
import ProposalFilter from '@/components/proposals/ProposalFilter.vue'
import ProposalSearch from '@/components/proposals/ProposalSearch.vue'
import ProposalEdit from '@/components/proposals/ProposalEdit.vue'
import ProposalShow from '@/components/proposals/ProposalShow.vue'
// end proposal 2

import store from '../store/index.js'

import { NAME_TOKEN } from '../config/config'
import { generateCacheBuster } from '../utils/cacheBuster';

Vue.use(VueRouter)

const routes = [
    { path: '/login', component: LoginComponent, name: 'login' },
    { path: '/closerequestpassword', component: CloseRequestPasswordComponent, name: 'closerequestpassword' },
    
    {
        path: '/admin',
        component: AdminComponent,
        meta: {auth: true},
        children: [
            { path: '/dashboard', component: DashboardComponent, name: 'admin.dashboard' },
            { path: '/users', component: UserComponent, name: 'admin.users.index'},
            { path: '/branches', component: BranchComponent, name: 'admin.branches.index' },
            { path: '/tenants', component: TenantComponent, name: 'admin.tenants.index' },
            { path: '/builders', component: BuilderComponent, name:'admin.builders.index' },
            { path: '/condominiums', component: CondominiumComponent, name:'admin.condominiums.index' },
            { path: '/properties', component: PropertyComponent, name:'admin.properties.index' },
            { path: '/properties_new', component: PropertyMenuComponent, name:'admin.propertymenu' },
            { path: '/favorites', component: FavoriteComponent, name:'admin.favorites.index' },
            { path: '/facs', component: FacComponent, name:'admin.facs.index' },
            { path: '/userrequests', component: UserRequestComponent, name:'admin.userrequests.index'},

            // novo user requests
            { path: '/user-requests', name:'user-requests-index', component: () => import('@/modules/user-requests/views/UserRequestIndex.vue')},
            { path: '/user-requests/search', name:'user-requests-search', component: () => import('@/modules/user-requests/views/UserRequestSearch.vue')},
            { path: '/user-requests/report', name:'user-requests-report', component: () => import('@/modules/user-requests/views/UserRequestReport.vue')},
            { path: '/user-requests/edit/:id', name:'user-requests-edit', component: () => import('@/modules/user-requests/views/UserRequestEdit.vue')},
           
            { path: '/properties2', component: PropertyIndex, name:'admin.properties2.index' },
            { path: '/properties2/store', component: PropertyStore, name:'admin.properties2.store' },
            { path: '/properties2/filter', component: PropertyFilter, name:'admin.properties2.filter' },
            { path: '/properties2/search', component: PropertySearch, name:'admin.properties2.search' },
            { path: '/properties2/show/:uuid', component: PropertyIndexShow , name: 'admin.properties2.show'},
            { path: '/properties2/edit/:uuid', component: PropertyEdit , name: 'admin.properties2.edit'},
            { path: '/properties2/deleted', component: PropertyDeleted , name: 'admin.properties2.deleted'},
            { path: '/properties2/property_portal_summary', component: PropertyPortalSummary, name:'admin.properties2.property_portal_summary' },
            { path: '/properties2/shop_windows', component: ShopWindow, name:'admin.properties2.shop_windows' },
            
            
            { path: '/facs2', component: FacIndex, name:'admin.facs2.index'},
            { path: '/facs2/store', component: FacStore, name:'admin.facs2.store'},
            { path: '/facs2/edit/:uuid', component: FacEdit, name:'admin.facs2.edit'},
            { path: '/facs2/filter', component: FacFilter, name:'admin.facs2.filter' },
            { path: '/facs2/search', component: FacSearch, name:'admin.facs2.search' },
            

            { path: '/proposals', component: ProposalIndex, name:'admin.proposals.index' },
            { path: '/proposals/store', component: ProposalStore, name:'admin.proposals.store' },
            { path: '/proposals/filter', component: ProposalFilter, name:'admin.proposals.filter' },
            { path: '/proposals/search', component: ProposalSearch, name:'admin.proposals.search' },
            { path: '/proposals/edit/:id', component: ProposalEdit, name:'admin.proposals.edit' },
            { path: '/proposals/show/:id', component: ProposalShow, name:'admin.proposals.show' },
            
        ]
    },

    { path: '/', component: LoginComponent, name: 'root'}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
    // 1. Verifica se a rota precisa de Auth
    if (to.matched.some(record => record.meta.auth)) {
        // 2. Verifica se o Vuex já diz que está logado
        if (store.state.auth.authenticated) {
            return next();
        }

        try {
            await store.dispatch('checkLogin');
            next();
        } catch (error) {
            console.error('[ROUTER] checkLogin falhou. Redirecionando para Login.', error);
            
            // Opcional: Salvar onde ele queria ir para voltar depois
            // store.commit('CHANGE_URL_BACK', to.name); 
            
            next({ name: 'login' });
        }
    } else {    
        // Evita loop infinito se a rota 'login' for pública mas você estiver logado
        // (Opcional: redirecionar para home se já estiver logado e tentar acessar login)
        if (to.name === 'login' && store.state.auth.authenticated) {
             return next({ name: 'home' }); // ou dashboard
        }

        next();
    }
});

export default router
